interface YouTubeEmbedProps {
  videoId: string;
  /** Aspect-ratio container; default keeps a 16:9 letterbox. */
  aspectRatio?: '16/9' | '4/3';
  className?: string;
  title?: string;
}

/**
 * Plain `<iframe>` wrapper. We rely on YouTube's own player rather than a
 * lite-youtube facade because admin previews are rare and editor click-through
 * is expected — not worth shipping the extra script.
 */
export function YouTubeEmbed({
  videoId,
  aspectRatio = '16/9',
  className = '',
  title = 'YouTube video preview',
}: YouTubeEmbedProps) {
  const ratioClass = aspectRatio === '4/3' ? 'aspect-[4/3]' : 'aspect-video';
  return (
    <div className={`overflow-hidden rounded-lg bg-black ${ratioClass} ${className}`}>
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
        className="h-full w-full"
      />
    </div>
  );
}
